export default "__VITE_ASSET__B7IDYTC7__"